/** Decides which session-check endpoint AuthContext should call on mount: the STAFF
 * `/auth/me` (njm_access cookie/token) or the AGENCY `/v1/agency-auth/me` (njm_agency_access
 * cookie). Pulled out of AuthContext.js into its own pure function so the exact dual-session
 * regression (2026-09, Bavna #24) has a permanent, fast, no-browser-needed unit test — see
 * resolveAuthPortal.test.js.
 *
 * `lastPortal` is the portal the user last explicitly AUTHENTICATED into (persisted in
 * localStorage as "njm_last_portal", set at each portal's own login). It takes priority over
 * `pathname` on purpose: a browser holding BOTH a valid staff session and a valid agency
 * session that navigates to any non-/agency URL (even an unmatched one like "/staff") must
 * keep checking whichever portal it actually last logged into, not silently fall back to
 * whichever the CURRENT url happens to suggest.
 */
export function resolveAuthPortal(pathname, lastPortal) {
  const isAgency = lastPortal ? lastPortal === "agency" : String(pathname || "").startsWith("/agency");
  return isAgency ? "agency" : "staff";
}
